import {createApp, defineAsyncComponent} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';
import './assets/main.css';
import mvcVueIntegration from "@/MvcVueIntegration.ts";
import VueCookies from 'vue-cookies';

const components = mvcVueIntegration.getComponents();

document.querySelectorAll('[data-vue-component]').forEach(element => {
	const componentName = (element as HTMLElement).dataset.vueComponent;

	if (!componentName) {
		console.error('No component name specified for element:', element);
		return;
	}

	const componentOrLoader = components[componentName];

	if (componentOrLoader) {
		const props = JSON.parse((element as HTMLElement).dataset.props || '{}');

		// Handle both sync and async (lazy-loaded) components
		let component;
		if (typeof componentOrLoader === 'function') {
			// It's a lazy-loaded component (function returning Promise)
			component = defineAsyncComponent(componentOrLoader as () => Promise<any>);
		} else {
			// It's a regular synchronous component
			component = componentOrLoader;
		}

		const app = createApp(component, props);
		const pinia = createPinia()
		pinia.use(piniaPluginPersistedstate)
		app.use(pinia);
		app.use(router);
		app.use(VueCookies);
		app.mount(element);
	} else {
		console.error(`Vue component "${componentName}" not found.`);
	}
});